module.exports = __webpack_public_path__ + "img/PG.50b57a36.svg";